import React from "react";
import { FormattedMessage } from "react-intl";
import styles from "./countryWrapper.module.scss";

const CountryWrapper = ({ children, countryName }) => {
  return (
    <div className={styles.country}>
      <h1 className={styles.country__title}>
        <span>
          <FormattedMessage id="Hello" />
        </span>
        {' '}{countryName}
      </h1>
      {children}
    </div>
  );
}

export default CountryWrapper;
